module.exports = __webpack_public_path__ + "static/media/login_bg_mobile.0afc8949.jpeg";